<template>
  <div v-if="!refresh">
    <div v-if="!loading && !profilePage && data.properties.filed_content != 'Hide'">
      <div v-if="!isDefalutPos" class="!flex">
        <div v-if="!data.properties.hideLabel" style="white-space: nowrap" class="!mb-0.5">
          <icons v-if="isIconRequired" :iconName="data.icon_name" class="mr-1"></icons>
          <label
            class="!text-LabelSize !font-LabelWeight !text-label-color mr-1"
            for="text"
            v-if="hasLabel && data.properties.filed_content != 'Hide'"
          >
            {{ label || data.label }}
          </label>
          <span
            v-if="
              data.validations.required &&
              data.properties.filed_content != 'Hide' &&
              hasLabel &&
              !isView
            "
            style="color: red; font-weight: bold"
          >
            *
          </span>
          <span>
            <el-popover
              v-if="data.description"
              placement="top-start"
              trigger="hover"
              :content="data.description"
              style="margin-left: 5px"
            >
              <i class="el-icon-info !ml-1" slot="reference"></i>
            </el-popover>
          </span>
        </div>
        <el-select
          :placeholder="data.placeholder"
          v-model="form[data.key]"
          :disabled="isFromDocument ? false : checkReadonly() || readonly()"
          :readonly="readonly()"
          v-if="!isView && !isList && data.properties.filed_content != 'Hide'"
          :suffix-icon="data.properties.el_icon"
          @change="applyFormRules"
          filterable
          remote
          clearable
          class="selectInput"
        >
          <el-option v-for="(option, index) of options" :value="option" :key="index"></el-option>
        </el-select>
        <el-select
          v-if="!isView && isList && data.properties.filed_content != 'Hide'"
          :placeholder="data.placeholder"
          v-model="form[data.key]"
          :disabled="isFromDocument ? false : checkReadonly() || readonly()"
          :readonly="readonly()"
          @change="applyFormRules"
          :suffix-icon="data.properties.el_icon"
          clearable
          class="selectInput"
        >
          <el-option v-for="(option, index) of options" :value="option" :key="index"></el-option>
        </el-select>
        <p v-if="isView && data.properties.filed_content != 'Hide'" :style="getStyle">
          <template v-if="form[data.key]">{{ form[data.key] }}</template>
          <template v-else>-</template>
        </p>
      </div>

      <el-row
        align="middle"
        v-else
        class="topfield"
        :class="{ 'topfield-sty': data.newlyAddedField }"
      >
        <el-col
          :span="showLabel ? 24 : data.description ? 20 : 24"
          v-if="!data.properties.hideLabel"
          ref="colRef"
          class="!mb-0.5"
        >
          <icons v-if="isIconRequired" :iconName="data.icon_name" class="mr-1"></icons>
          <label
            class="!text-LabelSize !font-LabelWeight !text-label-color"
            for="text"
            v-if="hasLabel && data.properties.filed_content != 'Hide'"
            :style="getLabelStyles"
          >
            {{ label || data.label }}
          </label>
          <span
            v-if="
              data.validations.required &&
              data.properties.filed_content != 'Hide' &&
              hasLabel &&
              !isView
            "
            style="color: red; font-weight: bold"
          >
            *
          </span>
          <span class="!ml-0.5">
            <el-popover
              v-if="data.description"
              placement="top-start"
              trigger="hover"
              :content="data.description"
              class="!ml-1"
            >
              <i class="el-icon-info" slot="reference"></i>
            </el-popover>
          </span>
        </el-col>
        <el-col v-else :span="showLabel ? 4 : data.description ? 20 : 24" ref="colRef">
          <span
            v-if="hasLabel"
            style="color: white; display: inline-block; height: 20px; opacity: 0"
          ></span>
          <span
            v-if="
              data.validations.required &&
              data.properties.filed_content != 'Hide' &&
              hasLabel &&
              !isView
            "
            style="color: red; font-weight: bold; margin-left: 5px; margin-right: 5px"
          >
            *
          </span>
        </el-col>
        <el-col>
          <el-select
            :placeholder="data.placeholder"
            v-model="form[data.key]"
            :disabled="isFromDocument ? false : checkReadonly() || readonly()"
            :readonly="readonly()"
            v-if="!isView && !isList && data.properties.filed_content != 'Hide'"
            :suffix-icon="data.properties.el_icon"
            @change="applyFormRules"
            filterable
            size="small"
            clearable
            class="selectInput"
            id="selectInput"
          >
            <el-option
              v-for="(option, index) of filteredOptions"
              :value="option"
              :key="index"
            ></el-option>
          </el-select>
          <el-select
            class="!text-DataSize !font-DataWeight !text-data-color"
            v-if="!isView && isList && data.properties.filed_content != 'Hide'"
            :placeholder="data.placeholder"
            v-model="form[data.key]"
            :disabled="isFromDocument ? false : checkReadonly() || readonly()"
            :readonly="readonly()"
            @change="applyFormRules"
            :suffix-icon="data.properties.el_icon"
            clearable
          >
            <el-option
              v-for="(option, index) of filteredOptions"
              :value="option"
              :key="index"
            ></el-option>
          </el-select>
          <p
            class="!text-DataSize !font-DataWeight !text-data-color"
            v-if="isView && data.properties.filed_content != 'Hide'"
            :style="getStyle"
          >
            <template v-if="form[data.key]">{{ form[data.key] }}</template>
            <template v-else>-</template>
          </p>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <div v-if="isView && data.properties.filed_content != 'Hide'">
        {{ form[data.key] }}
      </div>
      <div v-else>
        <el-select
          class="selectInput"
          v-if="data.properties.filed_content != 'Hide'"
          :placeholder="data.placeholder"
          v-model="form[data.key]"
          :disabled="isFromDocument ? false : checkReadonly()"
          :readonly="readonly()"
          @change="applyFormRules"
          :suffix-icon="data.properties.el_icon"
          clearable
        >
          <el-option v-for="(option, index) of options" :value="option" :key="index"></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
  import userPermissionsHelper from '@/mixins/userPermissionsHelper';
  import { mapGetters } from 'vuex';
  import { fetchGlobalVariableById } from '@/repo/globalVariables';
  export default {
    name: 'templates-formComponentsExecute-SelectExecute',
    mixins: [userPermissionsHelper],
    components: {},
    props: [
      'isVerticalView',
      'data',
      'label',
      'form',
      'isView',
      'hasLabel',
      'isFromDocument',
      'checkIsDisabled',
      'checkhideFields',
      'profilePage',
      'colorFields',
      'highlight',
      'hideOptions',
      'isIconRequired',
      'labelAlignments',
    ],
    data() {
      return {
        validations: [],
        options: [],
        isList: false,
        showLabel: true,
        loading: false,
        refresh: true,
        previous: [],
      };
    },
    mounted() {
      this.loading = true;
      if (this.data.options) {
        this.options = JSON.parse(JSON.stringify(this.data.options || []));
      }
      const hideOptionsForKey = this.hideOptions?.[this.data.key];
      if (Array.isArray(hideOptionsForKey) && hideOptionsForKey.length) {
        this.previous = JSON.parse(JSON.stringify(hideOptionsForKey || []));
      }
      if (this.data.is_global_variable && this.data.global_variable_id) {
        this.setGlobalVariableData();
      }
      if (this.form[this.data.key] !== '') {
        this.applyFormRules();
      }
      this.checkDataFormat();
      this.loading = false;
      setTimeout(() => {
        this.refresh = false;
      }, 100);
    },
    computed: {
      getLabelStyles() {
        return this.data.styles && this.data.styles.label_color
          ? `color: ${this.data.styles.label_color}`
          : `color: ${this.data.styles?.font?.color}`;
      },
      getStyle() {
        if (this.isVerticalView) {
          return `width: 50%`;
        }
        if (this.data.is_entity_variable && this.isView) {
          return `height:${this.data.height - 50}px; width: 100%`;
        }
        return `height:${this.data.height - 30}px; width: 100%`;
      },
      filteredOptions() {
        if (!this.hideOptions?.[this.data.key]) return this.options || [];
        const hidden = this.hideOptions?.[this.data.key] || [];
        const sourceOptions =
          this.data.is_global_variable && this.data.global_variable_id
            ? this.globalOptions || []
            : this.data.options || [];

        return sourceOptions.filter((opt) => {
          const val = typeof opt === 'object' ? opt.value : opt;
          return !hidden.includes(val);
        });
      },
      isDefalutPos() {
        if (this.data.styles && this.data.styles.labelStyle == 'right') {
          return false;
        } else {
          return true;
        }
      },
      ...mapGetters('globalVariables', ['getGlobalVariableById']),
      computedStyles() {
        const styles = {};
        if (this.data?.properties?.hideLabel) {
          styles.display = 'none';
        } else {
          styles.display = 'flex';
          if (this.labelAlignments || this.data?.styles?.labelAlignments) {
            styles.justifyContent = this.labelAlignments || this.data?.styles?.labelAlignments;
          }
        }

        return styles;
      },
    },
    methods: {
      defaultMethod() {
        if (this.data.default_value && this.form && this.data.key && !this.form[this.data.key]) {
          this.$set(this.form, this.data.key, this.data.default_value);
        } else if (
          !this.form[this.data.key] &&
          this.data.default_mapped_field &&
          this.form[this.data.default_mapped_field]
        ) {
          this.$set(this.form, this.data.key, this.form[this.data.default_mapped_field]);
        }
        this.$emit('applyFormRules');
      },
      checkDataFormat() {
        if (
          this.form[this.data.key] &&
          typeof this.form[this.data.key] == 'object' &&
          this.form[this.data.key].length
        ) {
          this.$set(this.form, this.data.key, this.form[this.data.key][0]);
        }
      },
      applyFormRules() {
        this.$emit('applyFormRules');
      },
      readonly() {
        if (this.data.field_assignable === 'read_only' && this.data.is_entity_variable) {
          return true;
        }
        if (
          this.data &&
          this.data.properties &&
          this.data.properties.filed_content === 'READ ONLY'
        ) {
          return true;
        }
      },
      checkReadonly() {
        if (this.checkIsDisabled) {
          return true;
        }
        if (this.fieldFilledByCurrentUser(this.data.filled_by) === 'false') {
          if (this.data.styles && this.data.styles.labelStyle) {
            if (this.data.styles && this.data.styles.labelStyle == 'hide') {
              this.showLabel = false;
            }
            if (this.data.styles && this.data.styles.labelStyle == 'right') {
              this.isDefalutPos = false;
            }
          }
          return !this.fieldFilledByCurrentUser(this.data.filled_by);
        } else {
          if (
            this.data &&
            this.data.properties &&
            this.data.properties.filed_content === 'DISABLED'
          ) {
            return true;
          }
          return !this.fieldFilledByCurrentUser(this.data.filled_by);
        }
      },

      async setGlobalVariableData() {
        let params = {
          id: this.data.global_variable_id,
        };
        let globalVariable = await fetchGlobalVariableById(params);

        if (globalVariable) {
          if (globalVariable.input_type == 'SELECT') {
            this.isList = true;
          }
          this.options = globalVariable.options;
        }
      },
    },
    watch: {
      hideOptions: {
        handler(data) {
          const selected = data?.[this.data.key];
          if (JSON.stringify(this.previous) !== JSON.stringify(selected || [])) {
            if (selected?.length) {
              const originalOptions =
                this.data.is_global_variable && this.data.global_variable_id
                  ? this.globalOptions || []
                  : JSON.parse(JSON.stringify(this.data.options));
              const selectedValues = selected.map((op) => (typeof op === 'object' ? op.value : op));
              this.options = originalOptions.filter((opt) => {
                const optionValue = typeof opt === 'object' ? opt.value : opt;
                return !selectedValues.includes(optionValue);
              });
            } else {
              if (this.data.is_global_variable && this.data.global_variable_id) {
                this.setGlobalVariableData();
              } else {
                this.options = JSON.parse(JSON.stringify(this.data.options));
              }
            }
            this.previous = JSON.parse(JSON.stringify(selected || []));
          }
        },
        deep: true,
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-input__inner {
    color: var(--color-data-color) !important;
    font-size: var(--data-size) !important;
    font-weight: var(--data-weight) !important;
  }
  .selectInput {
    width: 100% !important;
    .el-input {
      .el-input__inner {
        color: var(--color-data-color) !important;
        font-size: var(--data-size) !important;
        font-weight: var(--font-weight-DataWeight) !important;
        line-height: var(--text-DataSize--line-height) !important;
      }
    }
  }

  .label {
    white-space: normal;
  }

  .topfield {
    display: flex;
    flex-direction: column;
  }

  .extendable {
    display: contents;
  }

  .execute-view {
    font-weight: normal;
  }

  .el-select {
    @media (max-width: 760px) {
      width: 100% !important;
    }
  }
</style>
